import React from "react";
// import { Link } from 'react-router-dom';
import classes from "./Home.module.css";
import Header from "../common/Header/Header";
import Flags from "country-flag-icons/react/3x2";
import Footer from "../common/Footer/Footer";

function Home() {
  return (
    <div className="page-wrapper">
      <Header />
      <div className="static-background"></div>
      <div className="sect">
        <div className="sect-title">
          Over 10 years of expertise in{" "}
          <span className={classes.import}>Import</span>{" "}
          <span className={classes.and}>and</span>{" "}
          <span className={classes.export}>Export</span>
        </div>
        <div className="sect-content">
          We are{" "}
          <span className="sect-content-highlighted">
            Suxxus Global Trading Chennai Pvt. Ltd.
          </span>
        </div>
      </div>
      <div className="sect">
        <div className="sect-title-medium">A GLIMPSE ABOUT US</div>
        <div className="sect-content">
          <div className="content-grid-container">
            <div className="content-grid-container-column">
              <div className="content-grid-item content-grid-item-1">
                Established in 2013, we are an indenting and trading company. We
                use our widely experienced management in the field of
                international imports and exports to cater the needs of the
                Indian industry.
              </div>
              <div className="content-grid-item content-grid-item-4">
                We are based in Chennai and supply over 20000 mt tonnes of waste
                paper, annually, to the Indian paper industry.
              </div>
              <div className="content-grid-item content-grid-item-7">
                We are an established supplier of silicon to India and nearby
                countries.
              </div>
            </div>
            <div className="content-grid-container-column">
              <div className="content-grid-item content-grid-item-6">
                We supply silicon from major silicon manufacturing countries
                like China, Turkey, Malaysia, Latin America to aluminium
                foundries for the manufacture of various grades of aluminium
                ingots essential for automobiles and various other industries.
              </div>
              <div className="content-grid-item content-grid-item-3">
                We are helmed by a team having good experience in dealing with
                raw material suppliers in the field of waste paper, non ferrous
                scraps, silicon metal and various other industrial supplies.
              </div>
            </div>
            <div className="content-grid-container-column">
              <div className="content-grid-item content-grid-item-2">
                Our endeavour is to act as a genuine intermediary to deliver
                quality and add value to all our transactions
              </div>
              <div className="content-grid-item content-grid-item-5">
                Our product portfolio includes most major and minor grades as
                well as many country specific grades of Paper. We also supply
                5000mt silicon metal of various grades annually to Indian
                aluminium industry. We also deal in aluminium scraps like trump,
                tense, taint tabor, troma, twitch, talc, talons etc and have
                been selling to some of the major aluminium foundries in India.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sect">
        <div className="sect-title-medium">SUPPLY STATS</div>
        <div className="stat-container">
          <div className="stat-item">
            <div className="stat-item-num">
              5000+<span className="stat-unit">tonnes/year</span>
            </div>
            <div className="stat-item-desc">Silicon metal supplied</div>
          </div>
          <div className="stat-separator"></div>
          <div className="stat-item">
            <div className="stat-item-num">
              20000+<span className="stat-unit">tonnes/year</span>
            </div>
            <div className="stat-item-desc">Paper supplied</div>
          </div>
        </div>
      </div>

      <div className="sect">
        <div className="sect-title-medium">OUR SUPPLIER NETWORK</div>
        <div className="sect-title-submedium">Silicon</div>
        <div className="flag-list">
          <div className="flag-list-item">
            <Flags.CN className="flagimg"></Flags.CN>
            <div className="flag-list-item-text">China</div>
          </div>
          <div className="flag-list-item">
            <Flags.TR className="flagimg"></Flags.TR>
            <div className="flag-list-item-text">Turkey</div>
          </div>
          <div className="flag-list-item">
            <Flags.MY className="flagimg"></Flags.MY>
            <div className="flag-list-item-text">Malaysia</div>
          </div>
          <div className="flag-list-item">
            <Flags.BR className="flagimg"></Flags.BR>
            <div className="flag-list-item-text">Brazil</div>
          </div>
        </div>
        <div className="sect-title-submedium">Paper</div>
        <div className="flag-list">
          <div className="flag-list-item">
            <Flags.US className="flagimg"></Flags.US>
            <div className="flag-list-item-text">USA</div>
          </div>
          <div className="flag-list-item">
            <Flags.CA className="flagimg"></Flags.CA>
            <div className="flag-list-item-text">Canada</div>
          </div>
          <div className="flag-list-item">
            <Flags.IT className="flagimg"></Flags.IT>
            <div className="flag-list-item-text">Italy</div>
          </div>
          <div className="flag-list-item">
            <Flags.GB className="flagimg"></Flags.GB>
            <div className="flag-list-item-text">UK</div>
          </div>
          <div className="flag-list-item">
            <Flags.MT className="flagimg"></Flags.MT>
            <div className="flag-list-item-text">Malta</div>
          </div>
          <div className="flag-list-item">
            <Flags.ES className="flagimg"></Flags.ES>
            <div className="flag-list-item-text">Spain</div>
          </div>
          <div className="flag-list-item">
            <Flags.KW className="flagimg"></Flags.KW>
            <div className="flag-list-item-text">Kuwait</div>
          </div>
          <div className="flag-list-item">
            <Flags.ZA className="flagimg"></Flags.ZA>
            <div className="flag-list-item-text">South Africa</div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
